import React from 'react'
import Helmet from 'react-helmet'

import Layout from '../components/layout'
import pic04 from '../assets/images/pic04.jpg'
import HeaderAvalingua from '../components/HeaderAvalingua'
import i18n from '../components/i18n'

class Avalingua extends React.Component {
  constructor(props) {
    super(props)
    i18n.changeLanguage('pt')
  }
  render() {
    return (
      <Layout>
        <Helmet title="O que é Avalingua?" />
        <HeaderAvalingua />
        <div id="main">
          <section id="content" className="main">
            <span className="image main">
              <img src={pic04} alt="" />
            </span>
            <h2>O que é Avalingua?</h2>
            <p>
              Avalingua avalia automaticamente a qualidade linguística dos
              textos, tanto em galego como em castelhano (a versão para
              português está em desenvolvimento). Partindo de um texto escrito
              ou de um conjunto de textos, Avalingua faz uma análise
              pormenorizada mediante o uso de diferentes ferramentas de
              processamento da língua natural (PLN), incluindo um analisador
              sintático de dependências e variados recursos linguísticos. Foi
              desenvolvido pelo programa de Tecnologías da Linguagem Natural do
              CiTIUS, Universidade de Santiago de Compostela, Galiza.
            </p>
            <h2>Que vantagens tem esta tecnologia?</h2>
            <p>
              Permite ir além dos corretores habituais, pois não só consegue
              detetar erros ortográficos e lexicais mas também, graças a um
              analisador sintático automático, identifica problemas gramaticais
              mais complexos entre palavras relacionadas sintaticamente mas que
              se encontram a muita distância umas das outras.
            </p>
            <h2>Em que investigação está baseado Avalingua?</h2>
            <p>
              Avalingua é um conjunto de módulos de PLN de tecnología híbrida,
              combinando conhecimento de expertos, heurísticas, recursos
              linguísticos e aprendizagem automática. O número de tipos de erros
              e problemas linguísticos que se podem encontrar nos textos é tão
              elevado que está fora do escopo de qualquer classificador, pois
              não existem dados de treino com a suficiente diversidade. Para a
              avaliação automática de textos, acreditamos que é preciso
              tecnologia híbrida que inclua conhecimento explícito de expertos.
              O conhecimento sintático é codificado com o sistema DepPattern, um
              analisador de dependências compilado desde gramáticas provistas de
              um formalismo intuitivo para linguistas.
            </p>
            <h2>Quais as aplicações de Avalingua?</h2>
            <p>
              A aplicação mais directa é no âmbito da educação, com duas claras
              direções: pode ser usado como sistema de monitorização e avaliação
              de estudantes do ensino primário e secundário, ou/e como uma
              ferramenta de auto-aprendizagem de línguas segundas para
              estudantes estrangeiros.
            </p>
          </section>
        </div>
      </Layout>
    )
  }
}

export default Avalingua
